import React from "react";
import {FieldProps} from "formik";
import {Checkbox, CheckboxProps, FormControl, FormControlLabel} from "@material-ui/core";
import {useTranslation} from "react-i18next";

type CustomCheckboxProps = {
    caption: string
    readOnly?: boolean
}

const CustomCheckbox: React.FC<FieldProps & CheckboxProps & CustomCheckboxProps> = ({field, caption, readOnly, ...props}) => {
    const {t} = useTranslation();

    return <FormControl fullWidth>
        <FormControlLabel label={t(caption)} control={
            <Checkbox disabled={readOnly} {...field} {...props}/>
        }/>
    </FormControl>
};

export default CustomCheckbox;